import React from 'react';
import { Box, Typography} from '@material-ui/core';
import { translations } from '../../i18n/i18n';

const LegendItem = ({ color = null, colorBorder = '', icon = null, label }) => <div className="legend-item">
	{color && <div className='color' style={{border: colorBorder, background: color }}></div>}
	{icon && <div className="icon" dangerouslySetInnerHTML={{__html: icon}}></div>}
	<Typography variant="caption">{label}</Typography>
</div>;

const MapLegend = ({placeTypes, currentLayer}) => <Box mx={2} display="flex" flexDirection="column" alignItems="center">
	<Typography color="secondary" variant="overline" align="center">{translations.components.mapLegend.title}</Typography>

	<div className="legend-group-layers">
		{placeTypes.map(placeType => <LegendItem key={placeType.id} icon={placeType.icon} label={placeType.name} />)}
	</div>

	{currentLayer === 'DARE' && <div className="legend-group">
		<LegendItem color="rgb(224,222,216)" label="5000 m" />
		<LegendItem color="rgb(170,159,141)" label="4000 m" />
		<LegendItem color="rgb(170,135,83)" label="3500 m" />
		<LegendItem color="rgb(185,152,90)" label="3000 m" />
		<LegendItem color="rgb(195,167,107)" label="2500 m" />
		<LegendItem color="rgb(202,185,130)" label="2000 m" />
		<LegendItem color="rgb(211,202,157)" label="1500 m" />
		<LegendItem color="rgb(222,214,163)" label="1000 m" />
		<LegendItem color="rgb(239,235,192)" label="500 m" />
		<LegendItem color="rgb(172,208,165)" label="0 m" />
		<LegendItem color="rgb(200,230,255)" label={translations.components.mapLegend.seaLevel} />
		<LegendItem color="rgb(167,223,210)" label={translations.components.mapLegend.belowSeaLevel} />
		<LegendItem color="transparent" colorBorder="2px solid #8b4513" label={translations.components.mapLegend.elevation100} />
		<LegendItem color="transparent" colorBorder="1px solid #8b4513" label={translations.components.mapLegend.elevation50} />
	</div>}

	{currentLayer === 'DARE' && <div className="legend-group">
		<LegendItem color="rgb(128,255,0)" label={translations.components.mapLegend.broadLeavedForest} />
		<LegendItem color="rgb(0,166,0)" label={translations.components.mapLegend.coniferousForest} />
		<LegendItem color="rgb(77,255,0)" label={translations.components.mapLegend.mixedForest} />
		<LegendItem color="rgb(204,242,77)" label={translations.components.mapLegend.naturalGrasslands}/>
		<LegendItem color="rgb(166,255,128)" label={translations.components.mapLegend.moorsAndHeathland} />
		<LegendItem color="rgb(166,230,77)" label={translations.components.mapLegend.sclerophyllousVegetation} />
		<LegendItem color="rgb(166,242,0)" label={translations.components.mapLegend.transitionalWoodlandShrub}/>
		<LegendItem color="rgb(230,230,230)" label={translations.components.mapLegend.beachesDunesSands} />
		<LegendItem color="rgb(166,166,255)" label={translations.components.mapLegend.inlandMarshes} />
		<LegendItem color="rgb(77,77,255)" label={translations.components.mapLegend.peatBogs} />
		<LegendItem color="rgb(204,204,255)" label={translations.components.mapLegend.saltMarshes} />
		<LegendItem color="rgb(166,166,230)" label={translations.components.mapLegend.intertidalFlats} />
	</div>}

	{currentLayer === 'OSM' && <div className="legend-group">
		<LegendItem color="#dd376e" label={translations.components.mapLegend.motorway} />
		<LegendItem color="#f9b29c" label={translations.components.mapLegend.mainRoad} />
		<LegendItem color="#a1a1a1" label={translations.components.mapLegend.railway}/>
		<LegendItem color="#e4b2ec" label={translations.components.mapLegend.administrativeBoundary} />
	</div>}

	{currentLayer === 'OSM' && <div className="legend-group">
		<LegendItem color="#aad3df" label={translations.components.mapLegend.lakeAndWaterTank} />
		<LegendItem color="#8dc56c" label={translations.components.mapLegend.forest} />
		<LegendItem color="#abdf96" label={translations.components.mapLegend.natureReserve} />
		<LegendItem color="#cfeca8" label={translations.components.mapLegend.grasslandAndMeadow} />
		<LegendItem color="#cccccc" label={translations.components.mapLegend.pedestrianZone} />
		
		<LegendItem color="#f1dada" label={translations.components.mapLegend.commericalArea} />
		<LegendItem color="#ffaeb9" label={translations.components.mapLegend.industrialArea} />
	</div>}
</Box>;

export default React.memo(MapLegend);